<template>
  <footer class="page-footer">
    <div class="row">
      <div class="columns small-12 medium-4 large-4 footer-logo">
        <a href="javascript:;">
          <img class="imgs" style="width: 10rem;" alt src="../../assets/images/footer_banner.jpg" />
        </a>
      </div>
      <div class="columns small-12 medium-4 large-4" style="font-size: .75rem;">
        <div property="schema: address" typeof="PostalAddress" class="des-list">
          <a href="javascript:;">风险揭示书</a>
          <a href="javascript:;">隐私条款</a>
          <a href="javascript:;">免责声明</a>
          <a href="javascript:;">常见问题</a>
          <a href="javascript:;">联系我们</a>
        </div>
        <div style="text-align: center;">
          本网站所载资料版权为盛世长宏资本所有，未经许可不得使用，不得复制、转载、摘编
          <div>©2015 - 2020, 盛世长宏（北京）投资管理有限公司</div>
          <div>
            <img
              style="width: 18px;margin-right: 4px;margin-left: 4px;"
              src="../../assets/images/police.png"
              alt
            />
            京公网安备 11010202008644号
            <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#f0f0f0;text-decoration:none">
            	京ICP备20023676号-1号
            </a>
          </div>
        </div>
      </div>
      <div class="columns small-12 medium-4 large-4 footer-qrcode">
        <div v-if="url">
          <img class="imgs" style="width: 4.6rem;height: 4.6rem;" :src="url" alt />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { QrcodeCode } from "@/api/index";
export default {
  components: {},
  data() {
    return {
      url: null,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    QrcodeCode((res) => {
      if (res.code == 0) {
        this.url = res.data.url;
      }
    });
  },
  mounted() {},
};
</script>
<style lang='less' scoped>
.page-footer {
  width: 100%;
  .imgs {
    margin: 1rem 0;
  }
}
.des-list {
  text-align: center;
  margin-bottom: 1rem;
  a {
    padding: 0 0.6rem;
  }
}

.footer-logo {
  display: flex;
  align-items: center;
}
.footer-qrcode {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
@media print, screen and (min-width: 40em) {
  .row {
    display: block;
  }
}
@media print, screen and (min-width: 64.0625em) {
  .row {
    display: flex;
    align-items: center;
  }
}
@media screen and (min-width: 80em) {
  .row {
    display: flex;
    align-items: center;
  }
}
@media screen and (max-width: 40em) {
  .page-footer{
    .row {
      padding: 1rem 0.5rem;
    }
  }
}
</style>